<template>
  <el-table-column
    prop="ntax_partner.cost_centre"
    label="Költséghely"
    width="150"
    sortable="custom"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <span
        v-if="scope.row.ntax_partner"
      >
        {{ scope.row.ntax_partner.cost_centre }}
      </span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'ntax_partner.cost_centre',
  };
</script>
